<div class="modal-buscar-equipamentos">
  <div class="container-filtro">
    <input
      class="filtro-pesquisa color-input"
      (input)="filtrarEquipamentos($event)"
      [placeholder]="'COMPONENTS.MAPA.SEARCH_EQUIPMENT.placeholder' | transloco"
    />

    <object
      class="icone-lupa"
      data="assets/icones-filtros/icone-lupa.svg"
      type="image/svg+xml">
      Lupa
    </object>
  </div>

  <app-loading
    *ngIf="!equipamentosFiltrados"
    [linhas]="3"
    [colunas]="1"
    [height]="5.5">
  </app-loading>

  <ul
    *ngIf="equipamentosFiltrados && equipamentosFiltrados.length != 0; else naoTemEquipamentos"
    class="h-100 d-flex flex-column gap-2">

    <li *ngFor="let equipamento of equipamentosFiltrados; let i = index">
      <button
        class="btn btn-light informacoes-equipamento"
        [class.equipamento-ativo]="i == equipamentoSelecionado"
        (click)="atualizarEquipamentoSelecionado(equipamento, equipamento.gm_geolocalizacao_atual!, i)">

        <div class="linha-nome-badges">
          <img
            class="img-equipamento"
            [src]="'assets/mapa/equipamentos/' + equipamento.en_tipo + '.png'"
            alt="equipamento"
          />

          <h6 class="equipamento-nome">
            {{ equipamento.vc_frota }}
            {{ equipamento.operador_atual ? ' - ' + equipamento.operador_atual!.vc_nome : '' }}
          </h6>

          <div class="badges-wrapper">
            <span
              class="etiqueta status-badge"
              [class]="equipamento.status_atual">
              {{ traduzStatus(equipamento.status_atual, equipamento.bl_ativo) }}
            </span>

            <div class="etiqueta produtividade-badge">
              <img
                class="img-produtividade"
                src="assets/mapa/filtros/pesquisar-equipamentos/produtividade.png"
                alt="produtividade"
              />

              <span>
                {{ (equipamento.produtividade_total_por_equipamento || 0) | number : '1.2-2' }}
                {{ 'COMPONENTS.MAPA.SEARCH_EQUIPMENT.ha_unit' | transloco }}
              </span>
            </div>
          </div>
        </div>

        <div class="linha-tempo">
          <img
            class="img-relogio"
            src="assets/mapa/filtros/pesquisar-equipamentos/relogio.png"
            alt="relogio"
          />
          <span>
            {{ equipamento.ultima_informacao_trator?.ts_criado_em | calcularDiferencaTempo }}
          </span>
        </div>

        <div *ngIf="temAlertaVelocidade(equipamento)" class="linha-tempo">
          <img
            class="img-alerta"
            src="assets/mapa/equipamentos/15km-limit.svg"
            alt="alerta velocidade"
          />
          <span>
            {{ 'COMPONENTS.MAPA.SEARCH_EQUIPMENT.speed_alert' | transloco }}
          </span>
        </div>

      </button>
    </li>
  </ul>

  <ng-template #naoTemEquipamentos>
    <div *ngIf="!loading" class="d-flex align-items-center flex-column cor-cinza">
      <span>
        {{ 'COMPONENTS.MAPA.SEARCH_EQUIPMENT.no_equipment_available' | transloco }}
      </span>
      <span>
        {{ 'COMPONENTS.MAPA.SEARCH_EQUIPMENT.select_operation' | transloco }}
      </span>
    </div>
  </ng-template>
</div>

<app-dialog-encontrar-equipamentos
  [equipamento]="equipamentoSemDados"
  [mostrar]="mostrarDialogSemDados"
  (fechar)="fecharDialog()">
</app-dialog-encontrar-equipamentos>